(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["em-page-affiliates"]) return;
  try {
    

(function(){
  var f=document.getElementById('affform');
  if(!f)return;
  function mark(el,bad){ el.closest('.field').classList.toggle('bad',bad); }
  f.addEventListener('submit',function(e){
    var ok=true;
    ['af-name','af-where'].forEach(function(id){
      var el=document.getElementById(id), bad=!el.value.trim();
      mark(el,bad); if(bad)ok=false;
    });
    var em=document.getElementById('af-email');
    var badEm=!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em.value.trim());
    mark(em,badEm); if(badEm)ok=false;
    if(!ok){ e.preventDefault(); f.querySelector('.field.bad input').focus(); return; }
    /* valid: the form posts to Shopify, which sends it to their inbox and returns with the thank-you showing */
  });
  if(f.classList.contains('done')) f.querySelector('.sent').scrollIntoView({block:'center'});
  f.addEventListener('input',function(e){
    if(e.target.closest('.field.bad')) e.target.closest('.field').classList.remove('bad');
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["em-page-faq"]) return;
  try {
    
/* the jump row follows the groups on the page: one chip per .grp that has an id, labelled with its
   heading minus the full stop the headings carry */
(function(){
  function build(){
    var row=document.getElementById('faqjump'); if(!row)return;
    var grps=document.querySelectorAll('.grp[id]');
    if(!grps.length){row.remove();return;}
    var out='';
    for(var i=0;i<grps.length;i++){
      var h=grps[i].querySelector('h2'); if(!h)continue;
      var label=h.textContent.trim().replace(/\.$/,'');
      out+='<a href="#'+grps[i].id+'">'+label+'</a>';
    }
    row.innerHTML=out;
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',build);else build();
})();
/* Sept 9: a link can land on one answer. The jewelry page's cleansing note
   points at #cleanse (Sara, review 6:58: "if that led to a cleansing page,
   that totally makes sense"); the group chips still use the group ids, which
   are not <details>, so they are left alone. */
(function(){
  function openHash(){
    var h=location.hash&&location.hash.slice(1); if(!h)return;
    var d=document.getElementById(h); if(!d||d.tagName!=='DETAILS')return;
    d.open=true; d.scrollIntoView({block:'start'});
  }
  openHash(); window.addEventListener('hashchange',openHash);
})();

  } catch(e) { console.error(e); }
})();
})();
